import { useChannel as useAblyChannel } from "ably/react";
import type { NotificationListItem } from "@remi/types/notification/list";
import { NotificationMessageSchema } from "@remi/types/socket/message";

export const useNotificationChannel = (
  personId: string,
  callback: (message: NotificationListItem, eventId: string) => void,
) => {
  const channelName = `notifications-${personId}`;
  return useAblyChannel(channelName, (message) => {
    const parsed = NotificationMessageSchema.safeParse(message as unknown);
    if (!parsed.success) {
      return;
    }
    callback(parsed.data.data, parsed.data.name);
  });
};
